export default{
    address:{
        btnState:{
            btn1:'保存',
        },
        fromtitle:{
            from1:'所在地区',
            from2:'详细地址',
            from3:'邮政编码',
            from4:'收货人姓名',
            from5:'联系方式',
            from6:'设置为默认收货地址（设置后系统将在下单时自动选中该收货地址）',
            from7:'您已经添加了',
            from8:'请输入',
            from9:'操作',
            from10:'个收货地址，还可以添加',
            from11:'个'
        },
        tableList:{
            table1:'暂无数据',
            table2:'修改',
            table3:'删除',
            table4:'默认地址',
            table5:'设为默认',
            table6:'请选择所在地区',
            table7:'默认'
        },
        rulesObj:{
            rules1:'请选择所在地址',
            rules2:'请输入4-50字的详细地址信息',
            rules3:'请输入邮政编码',
            rules4:'请输入2-10字的收货人姓名！',
            rules5:'请输入手机号码',
            rules6:'请输入正确的手机号码',
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否删除该条地址信息？',
            confirm6:'地址删除成功！',
            confirm7:'设置成功！',
        }
    }
}